/* eslint-disable */
// prettier-ignore
function getPagesData() {
  const funcao = localStorage.getItem('funcao');
  if (funcao === 'Credor') return [];
  return [
    { title: 'Negociar', route: { name: 'negociacao' }, icon: 'DollarSignIcon', isBookmarked: true },
    { title: 'Chat', route: { name: 'apps-chat' }, icon: 'MessageSquareIcon', isBookmarked: true },
    { title: 'Acompanhamento', route: { name: 'acompanhamento' }, icon: 'ActivityIcon', isBookmarked: true },
    {title: 'Calendario', route: { name: 'calendar-pessoal' }, icon: 'CalendarIcon',  isBookmarked: true, hasNotificacion: true },
  ];
}

export default {
  pages: {
    key: 'title',
    get data() {
      return getPagesData();
    },
  },
}
/* eslint-enable */
